import type { ColumnDefinition } from "./columnDefinition";

export type ColumnFiltersAction =
  | SetFilterAction
  | DeleteFilterAction
  | SetColumnsAction
  | ClearFiltersAction;

export class SetFilterAction {
  readonly type = "set_filter";
  constructor(
    readonly payload: {
      columnId: string;
      filter: string;
    },
  ) {}
}

export class DeleteFilterAction {
  readonly type = "delete_filter";
  constructor(
    readonly payload: {
      columnId: string;
    },
  ) {}
}

export class SetColumnsAction {
  readonly type = "set_columns";
  constructor(readonly payload: ColumnDefinition[]) {}
}

export class ClearFiltersAction {
  readonly type = "clear_filters";
}
